<script>
import { periodicTasksMethods } from '@state/helpers'

export default {
  name: 'PeriodicTasksManualExecution',
  components: {},
  props: {
    instanceJson: {
      type: Object,
      required: true,
    },
    oncomplete: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    oncancel: {
      type: Function,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      modalShow: true,
      loading: false,
      submitting: false,
      taskExecuted: false,
      taskExecutionId: null,
      taskExecutionInfo: {},
      liveResultsInterval: null,
    }
  },
  computed: {},

  methods: {
    ...periodicTasksMethods,

    resetPrompt() {
      let context = this
      context.loading = false
      context.submitting = false
      context.taskExecuted = false
      context.taskExecutionId = null
      context.taskExecutionInfo = {}
      context.liveResultsInterval = null
    },

    manualExecuteObject() {
      let context = this
      context.submitting = true
      const promise = context.executeManuallyPeriodicTasks(
        context.instanceJson.url
      )
      return promise
        .then((data) => {
          context.$generate_toast(
            context,
            'info',
            `Tarea periódica envíada para ejecución`
          )
          context.taskExecuted = true
          context.submitting = false
          context.taskExecutionId = data.task_id
          context.liveResultsInterval = setInterval(() => {
            if (
              !context.taskExecutionInfo.task ||
              context.taskExecutionInfo.task.status === 'PENDING'
            ) {
              context.getLiveResults()
            } else {
              context.clearSelfInterval()
              context.submitting = false
            }
          }, 5000)
        })
        .catch((error) => {
          context.submitting = false
          context.$axios_error_noty(error, context)
        })
    },

    getLiveResults(uuid) {
      let context = this
      if (
        !context.taskExecutionId ||
        (context.taskExecutionInfo.task &&
          !context.taskExecutionInfo.task.status === 'PENDING')
      ) {
        context.clearSelfInterval()
        return
      }
      context.submitting = true
      const promise = context.getLiveResultsPeriodicTasks(
        context.taskExecutionId
      )
      return promise
        .then((data) => {
          context.taskExecutionInfo = data
        })
        .catch((error) => {
          context.clearSelfInterval()
          context.submitting = false
          context.$axios_error_noty(error, context)
        })
    },

    clearSelfInterval() {
      let context = this
      clearInterval(context.liveResultsInterval)
    },
  },
}
</script>

<template>
  <b-modal
    id="delete-modal"
    v-model="modalShow"
    title="Ejecutar tarea manualmente"
    ok-title="Ejecutar"
    ok-variant="success"
    size="lg"
    @hidden="
      () => {
        clearSelfInterval()
        oncancel()
      }
    "
    @ok.prevent="manualExecuteObject"
  >
    <b-container class="p-0">
      <b-row v-if="loading">
        <b-col md="12">
          <div class="text-center">
            <b-spinner
              label="Spinning"
              style="color: #195db2; width: 4rem; height: 4rem"
            ></b-spinner>
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col v-if="!taskExecuted" md="12">
          <p class="text-center">
            ¿Está seguro de ejecutar esta tarea periódica?
          </p>
        </b-col>
        <b-col v-else>
          <b-row>
            <b-col class="text-center" md="6">
              <p>
                La tarea ha sido envíada para ejecución
                <br />
                ID: {{ taskExecutionId }}
              </p>
              <hr />
              <h5>Estado</h5>
              <p
                v-if="
                  !taskExecutionInfo.task ||
                  taskExecutionInfo.task.status === 'PENDING'
                "
                class="text-warning"
              >
                <b-spinner small label="Spinning" variant="warning">
                </b-spinner> 
                <b> Actualizando información...</b>
              </p> 
              <p v-else class="text-primary">
                <b> La tarea ha terminado su ejecución </b>
              </p>
            </b-col>
            <b-col md="6">
              <b-card
                header-bg-variant="primary"
                header-text-variant="white"
                header="Resultados de la ejecución"
                footer-bg-variant="light"
                class="border border-primary"
              >
                <pre v-if="Object.keys(taskExecutionInfo).length">{{ JSON.stringify(taskExecutionInfo, null, 2) }}</pre>
                <span v-else class="text-muted">Esperando respuesta...</span>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button
        size="sm"
        variant="secondary"
        :disabled="submitting"
        @click="cancel"
      >
        Cancelar
      </b-button>

      <b-button
        v-if="
          taskExecutionInfo.task && taskExecutionInfo.task.status !== 'PENDING'
        "
        size="sm"
        variant="primary"
        :disabled="submitting"
        @click="resetPrompt"
      >
        <span v-if="!submitting"><i class="fe-repeat"></i> Volver a ejecutar </span>
        <b-spinner v-if="submitting" small label="Spinning" variant="light">
        </b-spinner>
      </b-button>
      <b-button
        v-else
        size="sm"
        variant="success"
        :disabled="submitting || taskExecuted"
        @click="ok"
      >
        <span v-if="!submitting"><i class="fe-play"></i> Ejecutar </span>
        <b-spinner v-if="submitting" small label="Spinning" variant="light">
        </b-spinner>
      </b-button>
    </template>
  </b-modal>
</template>
<style lang="scss">
</style>